import styled from 'styled-components'

import Card from '../../components/Card'
import ActionButton from '../../components/ActionButton'

export const Background = styled.div<{ $background: string }>`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  background-image: url(${(props) => props.$background});
  background-size: cover;
  background-position: center;
`

export const Logo = styled.img`
  width: 9rem;
  height: 6rem;
  margin-bottom: 2.4rem;
`

export const CardWrapper = styled(Card)`
  max-width: 60rem;
`

export const Text = styled.p`
  ${({ theme }) => theme.textStyles.textLarge}
  color: ${({ theme }) => theme.colors.nightRider};
  text-align: center;
  margin-bottom: 3.2rem;
`

export const Button = styled(ActionButton)``
